import { defineMessages, IntlShape } from "react-intl";

export const commonMessages = defineMessages({
  paymentStatus: {
    defaultMessage: "Payment Status"
  },
  languages: {
    defaultMessage: "Languages"
  },
  refercode: {
    defaultMessage: "Refercode"
  },
  availability: {
    defaultMessage: "Availability"
  },
  catalog: {
    defaultMessage: "Catalog"
  },
  customApps: {
    defaultMessage: "Local Apps"
  },
  dashboard: {
    defaultMessage: "Dashboard"
  },
  demo: {
    defaultMessage:
      "Just to let you know... You're in demo mode. You can play around with the dashboard but can't save changes.",
    description: "notification message after log in"
  },
  description: {
    defaultMessage: "Description"
  },
  descriptionJson: {
    defaultMessage: "Tip & Care"
  },
  discounts: {
    defaultMessage: "Discounts"
  },
  drafts: {
    defaultMessage: "Drafts"
  },
  email: {
    defaultMessage: "E-mail Address"
  },
  endDate: {
    defaultMessage: "End Date"
  },
  endHour: {
    defaultMessage: "End Hour"
  },
  firstName: {
    defaultMessage: "First Name"
  },
  generalInformations: {
    defaultMessage: "General Information"
  },
  lastName: {
    defaultMessage: "Last Name"
  },
  gender: {
    defaultMessage: "Gender"
  },
  birthday: {
    defaultMessage: "Birthday"
  },
  countryArea: {
    defaultMessage: "Country/Area"
  },
  phone: {
    defaultMessage: "Phone"
  },
  no: {
    defaultMessage: "No"
  },
  optionalField: {
    defaultMessage: "Optional",
    description: "field is optional"
  },
  properties: {
    defaultMessage: "Properties"
  },
  readOnly: {
    defaultMessage: "Saleor runs in read-only mode. Changes not saved."
  },
  requiredField: {
    defaultMessage: "This field is required"
  },
  savedChanges: {
    defaultMessage: "Saved changes"
  },
  sessionExpired: {
    defaultMessage: "Your session has expired. Please log in again to continue."
  },
  networkError: {
    defaultMessage: "Apollo network error."
  },
  somethingWentWrong: {
    defaultMessage: "Saleor ran into an unexpected problem"
  },
  startDate: {
    defaultMessage: "Start Date"
  },
  startHour: {
    defaultMessage: "Start Hour"
  },
  status: {
    defaultMessage: "Status"
  },
  summary: {
    defaultMessage: "Summary"
  },
  uploadImage: {
    defaultMessage: "Upload image",
    description: "button"
  },
  yes: {
    defaultMessage: "Yes"
  }
});

export const buttonMessages = defineMessages({
  accept: {
    defaultMessage: "Accept",
    description: "button"
  },
  back: {
    defaultMessage: "Back",
    description: "button"
  },
  cancel: {
    defaultMessage: "Cancel",
    description: "button"
  },
  clear: {
    defaultMessage: "Clear",
    description: "button"
  },
  confirm: {
    defaultMessage: "Confirm",
    description: "button"
  },
  create: {
    defaultMessage: "Create",
    description: "button"
  },
  delete: {
    defaultMessage: "Delete",
    description: "button"
  },
  done: {
    defaultMessage: "Done",
    description: "button"
  },
  edit: {
    defaultMessage: "Edit",
    description: "button"
  },
  manage: {
    defaultMessage: "Manage",
    description: "button"
  },
  nextStep: {
    defaultMessage: "Next",
    description: "go to next step, button"
  },
  ok: {
    defaultMessage: "OK",
    description: "button"
  },
  remove: {
    defaultMessage: "Remove",
    description: "button"
  },
  save: {
    defaultMessage: "Save",
    description: "button"
  },
  selectAll: {
    defaultMessage: "Select All",
    description: "select all options, button"
  },
  send: {
    defaultMessage: "Send",
    description: "button"
  },
  show: {
    defaultMessage: "Show",
    description: "button"
  },
  undo: {
    defaultMessage: "Undo",
    description: "button"
  }
});

export const sectionNames = defineMessages({
  apps: {
    defaultMessage: "Apps",
    description: "apps section name"
  },
  attributes: {
    defaultMessage: "Attributes",
    description: "attributes section name"
  },
  combo: {
    defaultMessage: "Product Sets",
    description: "ProductSets section name"
  },
  categories: {
    defaultMessage: "Categories",
    description: "categories section name"
  },
  countries: {
    defaultMessage: "Countries",
    description: "Countries section name"
  },
  collections: {
    defaultMessage: "Collections",
    description: "collections section name"
  },
  recommendationgroups: {
    defaultMessage: "Recommendation Groups"
  },
  recommendPopup: {
    defaultMessage: "Share & Earn"
  },
  configuration: {
    defaultMessage: "Configuration",
    description: "configuration section name"
  },
  currencyrates: {
    defaultMessage: "Currency Rates",
    description: "currency Rates section name"
  },
  cornermarks: {
    defaultMessage: "Corner Marks",
    description: "Product Corner Marks section name"
  },
  hotsearch: {
    defaultMessage: "Hot Search",
    description: "hot search section name"
  },
  customers: {
    defaultMessage: "Customers",
    description: "customers section name"
  },
  draftOrders: {
    defaultMessage: "Draft Orders",
    description: "draft orders section name"
  },
  home: {
    defaultMessage: "Home",
    description: "home section name"
  },
  instagram: {
    defaultMessage: "Content",
    description: "Instagram section name"
  },
  instagramList: {
    defaultMessage: "Content List",
    description: "Instagram section name"
  },
  label: {
    defaultMessage: "Content Label",
    description: "InsLabel name"
  },
  comment: {
    defaultMessage: "Content Comment",
    description: "InsComment name"
  },
  commentList: {
    defaultMessage: "Content Comment List",
    description: "InsComment name"
  },
  insAssociation: {
    defaultMessage: "New Association",
    description: "InsAssociation name"
  },
  navigation: {
    defaultMessage: "Navigation",
    description: "navigation section name"
  },
  orders: {
    defaultMessage: "Orders",
    description: "orders section name"
  },
  shipment: {
    defaultMessage: "Shipment",
    description: "Shipment section name"
  },
  erpstatusnote: {
    defaultMessage: "Order Status Note",
    description: "Shipment section name"
  },
  pages: {
    defaultMessage: "Pages",
    description: "pages section name"
  },
  pageManage: {
    defaultMessage: "Page Manage",
    description: "pages section name"
  },
  visualEditing: {
    defaultMessage: "Visual Editing",
    description: "pages section name"
  },
  pageEvent: {
    defaultMessage: "Page Manage Event",
    description: "pages section name"
  },
  permissionGroups: {
    defaultMessage: "Permission Groups",
    description: "permission groups section name"
  },
  permissionSite: {
    defaultMessage: "Shop Staff",
    description: "shop staff section name"
  },
  plugins: {
    defaultMessage: "Plugins",
    description: "plugins section name"
  },
  payments: {
    defaultMessage: "Payments",
    description: "payments section name"
  },
  productTypes: {
    defaultMessage: "Product Types",
    description: "product types section name"
  },
  products: {
    defaultMessage: "Products",
    description: "products section name"
  },
  soldoutcustompage: {
    defaultMessage: "Soldout Custom Page",
    description: "soldoutcustompage section name"
  },
  cover: {
    defaultMessage: "Product Detail Plugins",
    description: "products cover"
  },
  rotary: {
    defaultMessage: "Rotary",
    description: "rotary section name"
  },
  sales: {
    defaultMessage: "Sales",
    description: "sales section name"
  },
  serviceAccounts: {
    defaultMessage: "Service Accounts",
    description: "service accounts section name"
  },
  specialOffer: {
    defaultMessage: "Special Offer",
    description: "specialOffer section name"
  },
  shipping: {
    defaultMessage: "Shipping Methods",
    description: "shipping section name"
  },
  siteSettings: {
    defaultMessage: "Site Settings",
    description: "site settings section name"
  },
  siteLanguages: {
    defaultMessage: "Site Languages",
    description: "site languages section name"
  },
  staff: {
    defaultMessage: "Staff Members",
    description: "staff section name"
  },
  taxes: {
    defaultMessage: "Taxes",
    description: "taxes section name"
  },
  translations: {
    defaultMessage: "Translations",
    description: "translations section name"
  },
  vouchers: {
    defaultMessage: "Coupon Code",
    description: "vouchers section name"
  },
  warehouses: {
    defaultMessage: "Warehouses",
    description: "warehouses section name"
  },
  loginpopup: {
    defaultMessage: "Popup",
    description: "Login popup settings"
  },
  producttags: {
    defaultMessage: "Product Tags",
    description: "Product Tags settings"
  },
  webhooks: {
    defaultMessage: "Webhooks",
    description: "webhooks section name"
  },
  subscribers: {
    defaultMessage: "Subscribers",
    description: "Subscribers section name"
  },
  pageheaders: {
    defaultMessage: "Page Headers",
    description: "Page Headers section name"
  },
  register: {
    defaultMessage: "Register",
    description: "Register settings"
  },
  checkoutAdd: {
    defaultMessage: "CheckOut Add",
    description: "CheckOut Add settings"
  },
  productActivationSetting: {
    defaultMessage: "Product Activation Setting",
    description: "Product Activation Setting"
  },
  productLensType: {
    defaultMessage: "Lens Type",
    description: "Lens Type"
  }
});

export function translateBoolean(value: boolean, intl: IntlShape): string {
  return value
    ? intl.formatMessage(commonMessages.yes)
    : intl.formatMessage(commonMessages.no);
}
